import React from "react";
import { AlertBar, BarTone } from "@/components/ms";
import {
  ExchangeErrorInfo,
  ErrorActionType,
  getSeverityColor,
  getErrorDisplayTitle,
  getErrorDetails,
} from "@/utils/exchangeErrorMapper";

interface ExchangeErrorBannerProps {
  errorInfo: ExchangeErrorInfo;
  exchangeName: string;
  onReconnectTapped: () => void;
  onRemoveTapped?: () => void;
}

/** Alert bar · the source's keys are the state of this whole screen. Never dismissible. */
const SEVERITY_TONE: Record<string, BarTone> = {
  red: "problem",
  orange: "caution",
  blue: "notice",
  gray: "notice",
};

export const ExchangeErrorBanner: React.FC<ExchangeErrorBannerProps> = ({
  errorInfo,
  exchangeName,
  onReconnectTapped,
  onRemoveTapped,
}) => {
  const isRemoveAction = errorInfo.actionNeeded === ErrorActionType.REMOVE_INTEGRATION;
  const handleClick = isRemoveAction && onRemoveTapped ? onRemoveTapped : onReconnectTapped;
  const tone = SEVERITY_TONE[getSeverityColor(errorInfo.severity)] || "notice";

  return (
    <AlertBar
      tone={tone}
      bleed={false}
      action={{
        label: errorInfo.actionButtonTitle || "Reconnect",
        onClick: handleClick,
      }}
    >
      <b>
        {exchangeName ? `${exchangeName} — ` : ""}
        {getErrorDisplayTitle(errorInfo.actionNeeded)}.
      </b>{" "}
      {errorInfo.userFriendlyMessage} {getErrorDetails(errorInfo)}
    </AlertBar>
  );
};
